'strict mode';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import * as model from './model';
import RecipeView from './views/recipeView';
import SearchView from './views/searchView';
import PaginationView from './views/paginationView';
import ResultsView from './views/resultsView';
import BookmarksView from './views/bookmarksView';
import AddRecipeView from './views/addRecipeView';
import { CLOSE_WINDOW_SEC } from './config';

const controlRecipe = async () => {
  try {
    const id = window.location.hash.slice(1);

    if (!id) return;
    RecipeView.renderSpinner();

    //update view
    ResultsView.update(model.getSearchResultsPage());
    BookmarksView.update(model.state.bookmarks);

    //fetch data
    await model.loadRecipe(id);

    //render data
    RecipeView.render(model.state.recipe);
  } catch (err) {
    RecipeView.renderError();
  }
};

const controlSearchRecipes = async () => {
  try {
    ResultsView.renderSpinner();

    //get query
    const query = SearchView.getQuery();
    if (!query) return;

    //load search results
    await model.loadSearchResults(query);

    //render results
    ResultsView.render(model.getSearchResultsPage());

    //render initial pagination pages
    PaginationView.render(model.state.search);
  } catch (err) {
    console.log(err);
  }
};

const controlPagination = gotoPage => {
  //render results
  ResultsView.render(model.getSearchResultsPage(gotoPage));

  //render buttons
  PaginationView.render(model.state.search);
};

const controlServings = newServings => {
  //render recipe serving(update state)
  model.updateServings(newServings);

  //render new serving view
  RecipeView.render(model.state.recipe);
};

const controlAddBookmark = () => {
  //add || remove bookmark
  if (!model.state.recipe.bookmarked) model.addBookmark(model.state.recipe);
  else model.deleteBookmark(model.state.recipe.id);

  //bookmark recipe
  RecipeView.update(model.state.recipe);

  //update bookmark view
  BookmarksView.render(model.state.bookmarks);
};

const controlBookmarks = () => {
  //render initial bookmark view
  BookmarksView.render(model.state.bookmarks);
};

const controlNewRecipe = async newRecipe => {
  try {
    //show spinner
    AddRecipeView.renderSpinner();

    //upload new recipe
    await model.uploadRecipe(newRecipe);

    //render recipe
    RecipeView.render(model.state.recipe);

    //show success message
    AddRecipeView.renderSuccess();

    //render bookmarks view
    BookmarksView.render(model.state.bookmarks);

    //change ID in URL
    window.history.pushState(null, '', `#${model.state.recipe.id}`);

    //close window
    setTimeout(() => {
      AddRecipeView.toggleWindow();
    }, CLOSE_WINDOW_SEC * 1000);
  } catch (err) {
    AddRecipeView.renderError(err.message);
  }
};

const welcome = () => {
  console.log('Welcome to hall!');
};

const init = () => {
  BookmarksView.addBookmarksHandler(controlBookmarks);
  RecipeView.addRenderHandler(controlRecipe);
  RecipeView.addServingsHandler(controlServings);
  RecipeView.addBookmarkHandler(controlAddBookmark);
  SearchView.addSearchHandler(controlSearchRecipes);
  PaginationView.addPaginationHandler(controlPagination);
  AddRecipeView.addNewRecipeHandler(controlNewRecipe);
  welcome();
};

init();
